import { useState, useEffect } from 'react';
import { isClientSide } from 'src/utils/constants';

export const useViewportSize = () => {
  const [viewportWidth, setWidth] = useState(
    isClientSide ? window?.innerWidth : 0
  );
  const [viewportHeight, setHeight] = useState(
    isClientSide ? window?.innerHeight : 0
  );

  const handleResize = () => {
    setWidth(window?.innerWidth);
    setHeight(window?.innerHeight);
  };

  useEffect(() => {
    window?.addEventListener('resize', handleResize);
    return () => window?.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return {
    viewportWidth,
    viewportHeight
  };
};
